import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

/**
 * Password box with a reveal button.
 *
 * A password typed blind into a box that shows nothing back comes out as
 * "invalid email or password" with no clue which character was wrong. The eye
 * turns the box into plain text until it is pressed again.
 *
 * Everything except `className` is passed straight to the input, so this drops
 * in wherever an `<input type="password" className="input-field">` was.
 */
export default function PasswordInput({ className = "input-field", ...rest }) {
  const [shown, setShown] = useState(false);
  const label = shown ? "Hide the password" : "Show the password";

  return (
    <div className="relative">
      <input
        type={shown ? "text" : "password"}
        className={`${className} pr-10`}
        {...rest}
      />
      {/* tabIndex -1 so Tab still goes from the box to the next field, the way
          it did before there was a button beside it. */}
      <button
        type="button"
        tabIndex={-1}
        title={label}
        aria-label={label}
        aria-pressed={shown}
        onClick={() => setShown((s) => !s)}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-lg text-slate-400 transition-colors hover:text-navy focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        {shown ? <FiEyeOff size={16} /> : <FiEye size={16} />}
      </button>
    </div>
  );
}
